<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="datawrap" style="padding-top:0 !important">
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input
								placeholder="搜索消息"
								prefix-icon="el-icon-search"
								style="width: 200px;margin-right: 10px;"
								size="small"
								v-model="getdata.title"
								@input="getdata.page = 1;totalPage = 0;dataList();">
							</el-input>
							<el-select
								clearable
								style="width:120px "
								v-model="getdata.status" 
								filterable 
								size="small"
								placeholder="请选择状态"
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									label="已读"
									value="1">
								</el-option>
								<el-option
									label="未读"
									value="2">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" @click="allRead">标为已读</el-button>
							<el-button type="primary" size="small" @click='delAll'>一键删除</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey=""
							@selectList="selectList"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="true"
							:selection="true">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { rcbg } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import DelData from '@/components/delToast.vue'
	import myTables from '@/components/tables/tables.vue'
	let that;
	export default{
		data(){
			return{
				getdata:{
					user_id:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					title: "",
					page: 1,
					status: ""
				},
				tableHeader: [     // 表头
					{prop: 'title', label: '消息内容'},
					{prop: 'classs', label: '分类',formatData:function(val){
						if(val == 1){
							return '通知公告'
						}else if(val == 2){
							return '工作汇报'
						}else if(val == 3){
							return '活动'
						}else if(val == 4){
							return '年度计划'
						}else if(val == 5){
							return '思想汇报'
						}else if(val == 6){
							return '党费统计'
						}else{
							return '未知消息'
						}
					},width:"160"},
					{prop: 'dw', label: '党组织',width:'160'},
					{prop: 'addtime', label: '时间',formatData:function(val){
						return that.$changeTime(val)
					},width:"150"},
					{prop: 'message', label: '状态',formatData:function(val){},width:"100"},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '114',align:'center',
						oper: [
							{name: '立即处理', style: {color:'#bb0000'}, clickFun: this.godetail,show:true,limit:''},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del,show:true,limit:''},
						]
					}
				],
				tableData:[],
				totalPage:0,
				delList:[],
				readList:[],
				classList:[]
			}
		},
		components:{Page,DelData,myTables},
		methods:{
			// 数据
			dataList(){
				var that = this;
				that.tableData = [];
				rcbg.information(that.getdata).then(res => {
					that.tableData = res.data.pagedata;
					that.totalPage = res.data.count;
				})
			},
			// 分页筛选
			changedata(curret){
				var that = this;
				that.getdata.page = curret;
				that.dataList();
			},
			// 一键已读
			allRead(){
				if(that.readList.length == 0){
					Message.warning('请选择要标记的消息')
				}else{
					rcbg.allRead({
						zbid:that.$store.state.user.userinfo.id,
						flag:that.$store.state.user.userinfo.flag,
						type:that.classList,//通知公告1   活动汇报2
						tid:that.readList
					}).then(res => {
						if(res.code == 200){
							that.dataList();
							Message.success(res.msg)
						}else{
							Message.error(res.msg)
						}
					})
				}
			},
			// 详情
			godetail(data){
				var that = this;
				rcbg.informationDetail({
					zbid:that.$store.state.user.userinfo.id,
					flag:that.$store.state.user.userinfo.flag,
					tid:data.tid
				}).then(res => {
					if(res.code == 200){
						if(data.classes==1){
							// 通知公告
							that.$router.push({
								path:'/fbtz_detail',
								query:{
									id:data.tid
								}
							})
						}else if(data.classes==2){
							// 工作汇报
							that.$router.push({
								path:'/gzhb_detail',
								query:{
									id:data.tid,
									zbid:data.zbid,
									flag:data.flag,
								}
							})
						}else if(data.classes==3){
							// 活动
							that.$router.push({
								path:"/zzhd_detaill",
								query:{
									hy_flag:data.hyflag,
									hyid:data.hyid,
									dw:data.dw,
									uid:data.zbid,
								}
							})
						}else if(data.classes==4){
							// 年度计划
							that.$router.push({
								path:"/zdjh"
							})
						}else if(data.classes==5){
							// 思想汇报
							that.$router.push({
								path:"/sxhb"
							})
						}else if(data.classes==6){
							// 党费统计
							that.$router.push({
								path:"/dftj"
							})
						}else{
							Message.error("错误数据")
						}
					}else{
						Message.error(res.msg)
					}
					console.log(res)
				})
			},
			// 一键删除
			selectList(value){
				that.delList = []
				that.readList = []
				that.classList = []
				value.forEach(item => {
					that.delList.push(item.id);
					that.readList.push(item.tid);
					that.classList.push(item.classes);
				})
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						rcbg.delInformation({
							id:that.delList,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			del(data){
				that.delList = [];
				that.delList = [data.id];
				that.delData();
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
		},
		mounted() {
			that.dataList();
		},
		created() {
			that = this;
			that.$emit('selectTop',6)
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
	}
</style>

